
export const pt = {
  auth: {
    login: "Entrar",
    startFreeTrial: "Iniciar teste gratuito",
    register: "Registrar",
    email: "E-mail",
    password: "Senha",
    forgotPassword: "Esqueceu a senha?",
    alreadyHaveAccount: "Já tem uma conta?",
    dontHaveAccount: "Não tem uma conta?",
    errorDescription: "Ocorreu um erro",
    errorTitle: "Erro",
    successTitle: "Sucesso",
    successDescription: "Operação bem-sucedida",
    continueWithGoogle: "Continuar com Google",
    createAccount: "Criar conta",
    trialDescription: "14 dias de teste gratuito",
    emailPlaceholder: "seu@email.com",
    creating: "Criando...",
    create: "Criar",
    errorMessage: "Ocorreu um erro"
  },
  navigation: {
    pricing: "Preços",
    about: "Sobre",
    contact: "Contato",
    themes: "Temas",
    resources: "Recursos",
    home: "Início",
    dashboard: "Painel",
    products: "Produtos",
    orders: "Pedidos",
    customers: "Clientes",
    settings: "Configurações"
  },
  footer: {
    acceptedPayments: "Pagamentos aceitos",
    allRightsReserved: "Todos os direitos reservados",
    quickLinks: "Links rápidos",
    legalNotice: "Aviso legal",
    accessibility: "Acessibilidade",
    termsOfUse: "Termos de uso",
    support: "Suporte",
    followUs: "Siga-nos",
    socialMedia: "Encontre-nos nas redes sociais",
    newsletter: "Newsletter",
    subscribeNewsletter: "Assine nossa newsletter",
    emailPlaceholder: "Seu email",
    subscribe: "Assinar",
    changeLanguage: "Mudar idioma"
  },
  pricing: {
    title: "Planos e preços",
    subtitle: "Escolha o plano que melhor se adapta a você",
    startTrial: "Começar teste gratuito",
    mostPopular: "Mais popular",
    freeTrial: "14 dias de teste gratuito",
    perMonth: "/mês",
    basic: {
      name: "Básico",
      price: "11",
      description: "Para começar",
      features: [
        "1 loja",
        "100 produtos",
        "Suporte por email"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Para profissionais",
      features: [
        "3 lojas",
        "1000 produtos",
        "Suporte prioritário",
        "Análises avançadas"
      ]
    },
    enterprise: {
      name: "Empresa",
      price: "97",
      description: "Para grandes empresas",
      features: [
        "Lojas ilimitadas",
        "Produtos ilimitados",
        "Suporte dedicado",
        "API personalizada"
      ]
    }
  },
  profile: {
    title: "Meu Perfil",
    fullName: "Nome completo",
    phoneNumber: "Número de telefone",
    update: "Atualizar",
    updating: "Atualizando...",
    success: "Perfil atualizado com sucesso",
    error: "Erro ao atualizar perfil"
  },
  common: {
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    create: "Criar",
    search: "Buscar",
    filter: "Filtrar",
    sort: "Ordenar",
    actions: "Ações",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    close: "Fechar"
  }
};
